import { render, staticRenderFns } from "./MyEduAssessment.vue?vue&type=template&id=7bd8dd31"
import script from "./MyEduAssessment.vue?vue&type=script&lang=js"
export * from "./MyEduAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports